import api from "api";

// Análise do Instagram do perfil de produtor (contrato em
// ENG_API_Core-v1/docs/2026-10-16-instagram-analysis-frontend-handoff.md).
const instagramAnalyses = {
    // Histórico + `eligibility` (se o produtor pode pedir agora e, se não, por quê).
    list: () => {
        return api().get('/producer-profiles/me/instagram-analyses');
    },

    // Sem corpo: o @ vem do Instagram cadastrado no perfil de produtor.
    request: () => {
        return api().post('/producer-profiles/me/instagram-analyses');
    },

    get: (id) => {
        return api().get(`/producer-profiles/me/instagram-analyses/${id}`);
    },
};

export default instagramAnalyses;
